import { selectApi } from '@/modules/calendar/api';
import { getItemTypeAndIdFromUri, SearchResultTypeProvider } from '@/core/search/export';
import { AnalyticsSubTypeEvent, AnalyticsTypes } from '@/shared/analytics/export';

// Calendar event results in global search: the analytics payload.
export const eventSearchResultType: SearchResultTypeProvider = {
  async analyticsObject(item, actionType) {
    const { itemId } = getItemTypeAndIdFromUri(item.uri);
    const event = await selectApi.getEvent(itemId);
    return {
      type: AnalyticsTypes.EVENT,
      actionType,
      eventSubType: AnalyticsSubTypeEvent.DATA_EVENT,
      id: itemId,
      title: item.title,
      config: {
        date: event.date,
        dataReleaseId: event.dataReleaseId,
        dataSeriesIds: event.dataSeriesEntries.map(entry => entry.dataSeriesId),
        country: event.country,
        instantAnswers: event.instantAnswers?.map(i => ({
          instantAnswersSeriesId: i.instantAnswersSeriesId,
          instantAnswersInstanceId: i.instantAnswersInstanceId,
          questionIds: i.questions?.map(q => q.questionId) || [],
        })),
      },
    };
  },
};
